import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Button from "./Button";

const PaymentForm = ({ onCompletePayment }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    // Create a PaymentMethod
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (error) {
      console.error(error);
      setLoading(false);
      return;
    }

    // Send PaymentMethod ID to onCompletePayment function
    onCompletePayment(paymentMethod.id);
    setLoading(false);
  };

  return (
    <div className="payment-form">
      <CardElement />
      <Button
        disabled={!stripe || loading}
        loading={loading}
        text="Complete Payment"
        onClicked={() => handleSubmit()}
      />
    </div>
  );
};

export default PaymentForm;
